export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    title: '费用明细',
    field: 'v_expenseType',
    align: 'left',
    slots: {
      default: 'showItem'
    }
  }
]
